import React, { useEffect, useState } from "react";
import { listEpisodes } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";
import { Clock, ExternalLink } from "lucide-react";

const MediaPage = ({ kind = "podcast" }) => {
  const { lang } = useLang();
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    listEpisodes(kind, lang).then((d) => { setItems(d); setActive(d[0] || null); });
  }, [kind, lang]);

  const title = kind === "podcast" ? "SAT Podcast" : "SAT TV";
  const subtitle = kind === "podcast" ? "Die Spielregeln des Lebens — zum Hören." : "Die Mediathek der SAT — Doku, Interview, Masterclass.";

  return (
    <div className="pt-28 min-h-screen" data-testid={`media-${kind}-page`}>
      <div className="container-sat pt-8 pb-12">
        <div className="overline mb-4">{kind === "podcast" ? "Audio" : "Video"}</div>
        <h1 className="headline-xl text-5xl md:text-7xl">{title}</h1>
        <p className="serif italic text-xl text-white/55 mt-6 max-w-2xl">{subtitle}</p>
      </div>

      {active && (
        <section className="bg-[#050B1B] py-12">
          <div className="container-sat grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8">
              <div className="rounded-2xl overflow-hidden border border-white/10 bg-black aspect-video" data-testid="media-player">
                <iframe
                  src={active.embed_url}
                  title={active.title}
                  className="w-full h-full"
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="mt-6">
                <h2 className="serif text-3xl">{active.title}</h2>
                <p className="text-white/65 mt-3 leading-relaxed">{active.description}</p>
                <div className="flex gap-4 mt-4 text-xs text-white/45">
                  <span className="flex items-center gap-1"><Clock size={11} /> {active.duration_min} min</span>
                  {active.external_url && <a href={active.external_url} target="_blank" rel="noreferrer" className="flex items-center gap-1 hover:text-white"><ExternalLink size={11} /> {kind === "podcast" ? "Auf Spotify hören" : "Auf YouTube ansehen"}</a>}
                </div>
              </div>
            </div>
            <div className="lg:col-span-4 space-y-3" data-testid="media-list">
              <div className="overline mb-2">Alle Folgen</div>
              {items.map((ep) => (
                <button
                  key={ep.id}
                  onClick={() => setActive(ep)}
                  className={`w-full text-left p-4 rounded-xl border transition flex gap-3 ${active.id === ep.id ? "bg-white/[0.07] border-white/15" : "border-white/8 hover:bg-white/[0.03]"}`}
                  data-testid={`media-item-${ep.id}`}
                >
                  {ep.cover_image && <img src={ep.cover_image} alt="" className="w-16 h-16 rounded-lg object-cover" />}
                  <div className="flex-1">
                    <div className="text-sm text-white/85 line-clamp-2">{ep.title}</div>
                    <div className="text-xs text-white/40 mt-1">{ep.duration_min} min</div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default MediaPage;
